import { createContext } from 'react'

const BI_AUT004Context = createContext()

export { BI_AUT004Context }


